export const FEE_LABELS = {
  opening_fee: 'Ouverture de dossier',
  honoraires: 'Honoraires',
  composition_fee: 'Frais de composition',
  consular: 'Frais consulaires',
  consular_per_adult: 'Frais consulaires/adulte',
  admission: 'Procédure admission',
  procedure: 'Procédure générale',
  normal: 'Tarif normal',
  express: 'Tarif express',
  adulte: 'Adulte',
  enfant_mineur: 'Enfant mineur'
};

export const feeLabel = (key) => FEE_LABELS[key] || key;
